__turbopack_context__.v({
  "content": "ky4AfG_content",
  "optimizationContent": "ky4AfG_optimizationContent",
  "optimizationElement": "ky4AfG_optimizationElement",
  "root": "ky4AfG_root" + " " + __turbopack_context__.i(768839)["sectionPadding"],
});
